__turbopack_context__.v({
  "cardBox": "HowWeWork-module__o7OJ_a__cardBox",
  "desc": "HowWeWork-module__o7OJ_a__desc",
  "iconCircle": "HowWeWork-module__o7OJ_a__iconCircle",
  "mainDesc": "HowWeWork-module__o7OJ_a__mainDesc",
  "mainHeading": "HowWeWork-module__o7OJ_a__mainHeading",
  "sectionSpace": "HowWeWork-module__o7OJ_a__sectionSpace",
  "title": "HowWeWork-module__o7OJ_a__title",
});
